module.exports = __webpack_public_path__ + "static/media/btn_bg_03.7dc5829a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/btn_bg_03.png
// module id = 1742
// module chunks = 0 1